import {
  AspectRatio,
  Button,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  Box
} from '@chakra-ui/react';
import Link from 'next/link';
import { BookOpenIcon } from '@heroicons/react/outline';
import { LayoutContainer, GridPattern } from '@components/common';

export function Hero(): JSX.Element {
  return (
    <LayoutContainer verticalPadding="none" pos="relative">
      <AspectRatio
        ratio={1400 / 1190}
        w="800px"
        pos="absolute"
        pointerEvents="none"
        draggable={false}
        userSelect="none"
        zIndex={1}
      >
        <GridPattern />
      </AspectRatio>

      <Stack align="center" textAlign="center">
        <Heading
          as="h1"
          size="h1"
          color="white"
          fontSize={{ base: '32px', sm: '56px' }}
          lineHeight={1.1}
        >
          Pre-built components with
          <br />
          <Box mt={2} h="fit-content">
            <Text
              as="span"
              bgGradient="linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)"
              bgClip="text"
            >
              Everything you need
            </Text>
          </Box>
        </Heading>

        <Text
          fontSize={{ base: '16px', sm: '24px' }}
          color="dark-text"
          maxW="860px"
          // fontFamily={'heading'}
        >
          Clerk’s customizable components add powerful, full-featured user and
          organization management capabilities to your application in mere
          minutes.
        </Text>

        <Flex
          flexDir={{ base: 'column', sm: 'row' }}
          align="center"
          justify="center"
          w="full"
          gap={4}
          pos="relative"
          pt="32px"
          zIndex={10}
        >
          <Link href={process.env.NEXT_PUBLIC_DASHBOARD_URL as string}>
            <Button cursor="pointer" variant="base" fontSize="md" minW="225px">
              Start Building
            </Button>
          </Link>

          <Link href="/docs">
            <Button
              leftIcon={<Icon as={BookOpenIcon} boxSize={5} />}
              variant={'white'}
              fontSize="md"
              minW="225px"
            >
              Read documentation
            </Button>
          </Link>
        </Flex>
      </Stack>
    </LayoutContainer>
  );
}
